import React, { useState } from "react";
import type { PlayerReferralProps, PromoProps } from "../../types";
import { useColors } from "../../constants/useColors";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList } from "react-native";
import { Icons, SearchBox } from "../../Components";
import moment from "moment-mini";

type ReferralSelectorProps = {
    player_referrals:PlayerReferralProps[],
    active_referral?:PlayerReferralProps,
    promos:PromoProps[],
    onSelectReferral:(player_referral:PlayerReferralProps | undefined) => void
}
const ReferralSelector = ({ active_referral, promos, player_referrals, onSelectReferral }:ReferralSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);
    const [ search, setSearch ] = useState('');

    const filtered_referral = player_referrals.filter(pr => pr.referral_code.toLowerCase().includes(search.toLowerCase())).slice(0,10)

    const renderReferrals = (data:{ item:PlayerReferralProps, index:number }) => {
        const promo = promos.find(p => p.promo_id == data.item.promo_id);
        if(!promo){ return <></> }
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectReferral(data.item) }}
            >
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.referral_code}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{promo.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ padding:15 }} float>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => { setVisible(!visible); onSelectReferral(undefined)}}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_referral?.referral_code ?? 'Select Referral'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <SearchBox
                onChange={(text) => setSearch(text)}
                hide_search_button
            />
            <FlatList
                data={filtered_referral.sort((a,b) => moment(a.create_datetime).unix() - moment(b.create_datetime).unix())}
                key={'group_selector'}
                keyExtractor={item => item.player_referral_id.toString()}
                renderItem={renderReferrals}
            />
            </View>
            :<></>}
        </View>
    )
}

export default ReferralSelector